import { useEffect, useCallback } from 'react';
import { useConfirmStore } from '../store/useConfirmStore';

export function ConfirmDialog() {
  const { visible, title, message, confirmText, cancelText, danger, close } = useConfirmStore();

  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (!visible) return;
      if (e.key === 'Escape') close(false);
      if (e.key === 'Enter') close(true);
    },
    [visible, close],
  );

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  if (!visible) return null;

  return (
    <div className="confirm-overlay" onClick={() => close(false)}>
      <div className="confirm-card" onClick={(e) => e.stopPropagation()}>
        {title && <div className="confirm-title">{title}</div>}
        <div className="confirm-message">{message}</div>
        <div className="confirm-actions">
          <button className="btn btn-outline confirm-btn-cancel" onClick={() => close(false)}>
            {cancelText}
          </button>
          <button
            className={`btn confirm-btn-ok${danger ? ' confirm-btn-danger' : ''}`}
            onClick={() => close(true)}
            autoFocus
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
